import React, { useContext, useEffect, useState } from 'react';
import './index.css';
import { FaRegAddressCard } from "react-icons/fa6";
import CustomInput from '../../../../../../components/CustomFormTag/CustomInput';
import CustomDate from '../../../../../../components/CustomFormTag/CustomDate';
import CustomSelect from '../../../../../../components/CustomFormTag/CustomSelect';
import CustomRadio from '../../../../../../components/CustomFormTag/CustomRadio';
import { filterDataContext } from '../../../../../../App';
import { CITY_LIST_API } from '../../../../../../APIs';
import { CiEdit } from "react-icons/ci";
import { FaCheck } from "react-icons/fa";
import CustomCheckBox from '../../../../../../components/CustomFormTag/checkbox';


const GuestDetailCard = ({ guestNumber, eventId, handlePreCheckout, guestRequired, fieldRefs, checkForCheckoutPage, setFieldError, eventRequirements, values, eventIndex, guestIndex, ticketIndex, setFieldValue, showGuestError, setShowGuestError }) => {
    const { countryData } = useContext(filterDataContext)

    const [cityData, setCityData] = useState([])
    const [enableEdit, setEnableEdit] = useState(false)

    const genderSelectOptions = ["Male", "Female", "unknown"]


    const handleCountryChange = (option, name) => {
        setFieldValue(name, option.label)
        if (guestRequired?.hasOwnProperty("city")) {
            setFieldValue(`BookingData[${eventIndex}].tickets[${ticketIndex}].guests[${guestIndex}].city`, "")
            fetchCityList(option.id)
        }
    }

    const handleCityChange = (option, name) => {
        setFieldValue(name, option.label)
    }


    const fetchCityList = async (id) => {
        try {
            const response = await CITY_LIST_API({ id })
            if (response && response?.status) {
                setCityData(response?.data)
            }
        } catch (error) {
            console.log(error, "CITY_LIST")
        }
    }

    const checkForGuestInfoRequired = (eventRequirements) => {
        const eventRequirementsData = eventRequirements?.[0]?.[eventId]
        if (eventRequirementsData) {
            if (eventRequirementsData.includes("all_persons") && eventRequirementsData.includes("pre_checkout")) {
                return true
            }
            if (eventRequirementsData.includes("lead_guest") && eventRequirementsData.includes("pre_checkout")) {
                if (guestRequired?.lead_guest) {
                    return true
                } else {
                    return false
                }
            }
        }
    }

    const handelChangeGender = (e) => {
        const name = e.target.name
        const value = e.target.value
        setFieldValue(name, value)
    }

    const handleUpdateDetails = () => {
        if (enableEdit) {
            setEnableEdit(false)
            handlePreCheckout(values)
        } else {
            setEnableEdit(true)
        }
    }

    return (
        <div className="guest-detail-card" ref={(el) => (fieldRefs.current[`guest_${eventIndex}${ticketIndex}${guestIndex}`] = el)} >
            <div className="guest-number">
                <div className='guest_info' >
                    <span><FaRegAddressCard /></span>
                    <h3>Guest {guestNumber + 1}</h3>
                    {
                        guestRequired?.lead_guest && (
                            <div className="lead-guest-indicator">
                                <span className="lead-guest-icon">⭐</span>
                                <span className="lead-guest-label">Lead Guest</span>
                            </div>
                        )
                    }
                </div>

                <div className='guest_checkout_edit' >
                    {
                        !guestRequired?.lead_guest &&
                        <CustomCheckBox
                            text={""}
                            value={values?.BookingData?.[eventIndex]?.tickets?.[ticketIndex].guests?.[guestIndex]?.activeGuest}
                            setValue={setFieldValue}
                            name={`BookingData[${eventIndex}].tickets[${ticketIndex}].guests[${guestIndex}].activeGuest`}
                            disabled={guestRequired?.lead_guest}
                        />
                    }
                    {
                        checkForCheckoutPage &&
                        <p
                            className="guest_info_edit"
                            onClick={handleUpdateDetails}
                        >
                            {enableEdit ? (
                                <>
                                    <FaCheck className="edit_icon" />
                                    Update
                                </>
                            ) : (
                                <>
                                    <CiEdit className="edit_icon" />
                                    Edit
                                </>
                            )}
                        </p>
                    }

                </div>


            </div>
            <form className="guest-form">
                {
                    guestRequired?.hasOwnProperty("contact_email") &&
                    <CustomInput
                        label={"Email"}
                        name={`BookingData[${eventIndex}].tickets[${ticketIndex}].guests[${guestIndex}].contact_email`}
                        placeholder={"Enter email"}
                        inputClass={checkForGuestInfoRequired(eventRequirements)}
                        checkForCheckoutPage={enableEdit ? false : checkForCheckoutPage}

                    />
                }
                {
                    guestRequired?.hasOwnProperty("first_name") &&
                    <CustomInput
                        label={"First Name"}
                        name={`BookingData[${eventIndex}].tickets[${ticketIndex}].guests[${guestIndex}].first_name`}
                        placeholder={"Enter first name"}
                        inputClass={checkForGuestInfoRequired(eventRequirements)}
                        checkForCheckoutPage={enableEdit ? false : checkForCheckoutPage}
                    />
                }
                {
                    guestRequired?.hasOwnProperty("last_name") &&
                    <CustomInput
                        label={"Last Name"}
                        name={`BookingData[${eventIndex}].tickets[${ticketIndex}].guests[${guestIndex}].last_name`}
                        placeholder={"Enter last name"}
                        inputClass={checkForGuestInfoRequired(eventRequirements)}
                        checkForCheckoutPage={enableEdit ? false : checkForCheckoutPage}
                    />

                }
                {
                    guestRequired?.hasOwnProperty("gender") &&
                    <CustomRadio options={genderSelectOptions} label={"Select gender"}
                        checkForCheckoutPage={enableEdit ? false : checkForCheckoutPage}

                        name={`BookingData[${eventIndex}].tickets[${ticketIndex}].guests[${guestIndex}].gender`}
                        inputClass={checkForGuestInfoRequired(eventRequirements)}
                        onChange={handelChangeGender}
                        selectedValue={values?.BookingData?.[eventIndex]?.tickets?.[ticketIndex]?.guests?.[guestIndex]?.gender}
                    />

                }
                {
                    guestRequired?.hasOwnProperty("contact_phone") &&
                    <CustomInput
                        label={"Contact"}
                        name={`BookingData[${eventIndex}].tickets[${ticketIndex}].guests[${guestIndex}].contact_phone`}
                        placeholder={"Enter contact number"}
                        inputClass={checkForGuestInfoRequired(eventRequirements)}
                        checkForCheckoutPage={enableEdit ? false : checkForCheckoutPage}


                    />

                }
                {
                    guestRequired?.hasOwnProperty("zip") &&
                    <CustomInput
                        label={"Zipcode"}
                        name={`BookingData[${eventIndex}].tickets[${ticketIndex}].guests[${guestIndex}].zip`}
                        placeholder={"Enter Zipcode"}
                        inputClass={checkForGuestInfoRequired(eventRequirements)}
                        checkForCheckoutPage={enableEdit ? false : checkForCheckoutPage}


                    />

                }
                {
                    guestRequired?.hasOwnProperty("street_name") &&
                    <CustomInput
                        label={"Street Name"}
                        name={`BookingData[${eventIndex}].tickets[${ticketIndex}].guests[${guestIndex}].street_name`}
                        placeholder={"Enter street name"}
                        inputClass={checkForGuestInfoRequired(eventRequirements)}
                        checkForCheckoutPage={enableEdit ? false : checkForCheckoutPage}


                    />

                }
                {

                    guestRequired?.hasOwnProperty("passport_number") &&
                    <CustomInput
                        label={"Passport number"}
                        name={`BookingData[${eventIndex}].tickets[${ticketIndex}].guests[${guestIndex}].passport_number`}
                        placeholder={"Enter Passport number"}
                        inputClass={checkForGuestInfoRequired(eventRequirements)}
                        checkForCheckoutPage={enableEdit ? false : checkForCheckoutPage}


                    />
                }
                {

                    guestRequired?.hasOwnProperty("country_of_residence") &&
                    <CustomSelect label={"Country of residence"}
                        options={countryData?.map((item) => {
                            return {
                                label: item.country_Code,
                                id: item.country_id
                            }
                        })}
                        inputClass={checkForGuestInfoRequired(eventRequirements)}
                        onChange={(options) => handleCountryChange(options, `BookingData[${eventIndex}].tickets[${ticketIndex}].guests[${guestIndex}].country_of_residence`)}
                        value={values.BookingData?.[eventIndex]?.tickets?.[ticketIndex]?.guests?.[guestIndex]?.country_of_residence}
                        name={`BookingData[${eventIndex}].tickets[${ticketIndex}].guests[${guestIndex}].country_of_residence`}
                        checkForCheckoutPage={enableEdit ? false : checkForCheckoutPage}

                    />
                }
                {
                    guestRequired?.hasOwnProperty("city") &&
                    <CustomSelect label={"city"}
                        name={`BookingData[${eventIndex}].tickets[${ticketIndex}].guests[${guestIndex}].city`}
                        value={values.BookingData?.[eventIndex]?.tickets?.[ticketIndex]?.guests?.[guestIndex]?.city}
                        inputClass={checkForGuestInfoRequired(eventRequirements)}
                        onChange={(options) => handleCityChange(options, `BookingData[${eventIndex}].tickets[${ticketIndex}].guests[${guestIndex}].city`)}
                        options={cityData?.map((item) => {
                            return {
                                label: item.city_Name,
                                id: item.city_Name
                            }
                        })}
                        checkForCheckoutPage={enableEdit ? false : checkForCheckoutPage}

                    />
                }
                {
                    guestRequired?.hasOwnProperty("date_of_birth") &&
                    <CustomDate label={"Date of birth"}
                        name={`BookingData[${eventIndex}].tickets[${ticketIndex}].guests[${guestIndex}].date_of_birth`}
                        value={values.BookingData?.[eventIndex]?.tickets?.[ticketIndex]?.guests?.[guestIndex]?.date_of_birth}
                        inputClass={checkForGuestInfoRequired(eventRequirements)}
                        checkForCheckoutPage={enableEdit ? false : checkForCheckoutPage}
                        maxDate={new Date()}

                    />
                }
            </form>

        </div>
    );
};

export default GuestDetailCard;
